/// <reference path="./detect.internetbrowser.d.ts" />
/*!
 * @preserve
 * Detect.js
 * BrowserInfoCollector Frontend JS for dein-ip-check.de (Modul: detectSystem->detectInternetBrowser)
 *
 * @version 3.1.6
 * @author Jens Dutzi <jens.dutzi@tf-network.de>
 * @website http://www.dein-ip-check.de
 * @license Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

export interface webglversion {
    major: string,
    minor: string | null,
}

export class detectInternetBrowser {
    /**
     * Prüfe ob es sich beim aktuellen Browser um den IE <11 bzw. IE 11 oder Edge handelt 
     * (nicht Chromium-basierend)
     * 
     * @return boolean IE Status
     */
    public static isIE():boolean {
        if (navigator.appName === 'Microsoft Internet Explorer') {
            return true
        } else if (navigator.appName === 'Netscape' && /Trident/.test(navigator.userAgent)) { 
            return true
        }
        return false
    }
    
    /**
     * Prüfe welche Javascript Version unterstützt wird
     *
     * @return String Javascript-Version
     */
    public static getJavascriptVersion():string {
        // Mögliche Versionen zusammenstellen (1.0 bis 4.0)
        let jverlist = [];

        for (let i = 10; i < 41; i++) {
            jverlist.push( (i/10).toFixed(1) );
        }

        // Javascript per injecten und prüfen welche davon ausgeführt wurden.
        let d = document;
        let g, s;
        for (let i = 0; i < jverlist.length; i++) {
            g = d.createElement('script');
            s = d.getElementsByTagName('script')[0];

            g.setAttribute("language", "JavaScript" + jverlist[i]);
            g.text = "window.jsversion='" + jverlist[i] + "';";
            s.parentNode.insertBefore(g, s);
        }

        return (<any>window)["jsversion"];
    }

    /**
     * ActiveX Support vorhanden?
     *
     * @return Boolean ActiveX-Verfügbarkeit
     */
    public static getActiveXSupport():boolean {
        return typeof ((<any>window).ActiveXObject) != "undefined";
    }

    /**
     * Anzahl der Seiten in der History abrufen
     *
     * @return String Phrase mit Anzahl der URLs
     */
    public static getHistory():number {
        return window.history.length;
    }

    /**
     * IndexDB-Storage vorhanden?
     *
     * @return boolean
     */
    public static getIndexDBStatus():boolean {
        return ('indexedDB' in window) || ('mozIndexedDB' in window) || ('webkitIndexedDB' in window) || ('msIndexedDB' in window);
    }

    /**
     * Local-Storage vorhanden?
     *
     * @return boolean
     */
    public static getLocalStorageStatus():boolean {
        let fail;
        let storage:Storage;
        let test:boolean = false;

        try {
            let uid = new Date;

            (storage = window.localStorage).setItem(uid.toDateString(), uid.toDateString());
            fail = storage.getItem(uid.toDateString()) !== uid.toDateString();
            storage.removeItem(uid.toDateString());
            test = !fail;
        } catch(e) { }

        return test;
    }

    /**
     * Session-Storage vorhanden?
     *
     * @return boolean
     */
    public static getSessionStorageStatus():boolean {
        let fail;
        let storage:Storage;
        let test:boolean = false;


        try {
            let uid = new Date;

            (storage = window.sessionStorage).setItem(uid.toDateString(), uid.toDateString());
            fail = storage.getItem(uid.toDateString()) !== uid.toDateString();
            storage.removeItem(uid.toDateString());
            test = !fail;
        } catch(e) {}

        return test;
    }

    /**
     * Liste mit Fenster-Elementen
     *
     * @returns {Array}
     */
    public static getWindowElements():string[] {
        let windowselements = [];

        // Elemente die im jeder Browser vorhanden sind
        if(typeof window.menubar !== "undefined") {
            if (window.menubar.visible) {
                windowselements.push("Menüleiste");
            }
        }
        if(typeof window.toolbar !== "undefined") {
            if (window.toolbar.visible) {
                windowselements.push("Toolbar");
            }
        }
        if(typeof window.scrollbars !== "undefined") {
            if (window.scrollbars.visible) {
                windowselements.push("Scroll-Leiste");
            }
        }
        if(typeof window.statusbar !== "undefined") {
            if (window.statusbar.visible) {
                windowselements.push("Status-Leiste");
            }
        }

        // Elemente die nur bei bestimmten Browser existieren
        /** @namespace window.locationbar */
        if(typeof window.locationbar !== "undefined") {
            if(window.locationbar.visible) { windowselements.push("Adresszeile"); }
        }
        /** @namespace window.personalbar */
        if(typeof window.personalbar!== "undefined") {
            if(window.personalbar.visible) { windowselements.push("Bookmarkleiste"); }
        }

        return windowselements;
    }

    /**
     * Third-Party Cookie Test
     */
    public static start3PartyCookieTest(element: string, sucess: Function, failed: Function) {
        // Test starten und Data-Tag für Testbegin setzen
        $(element).data("test3dPartyCookieStarted", true);

        // URL und Ausgabe-Element für Step 1
        let step1URL = "https://3partycookietest.leak-test.de/cookie.step1.php";
        let resultElement = $(element);

        // Injekte das Javascript zum Start des Tests
        resultElement.html("Prüfung läuft (1)");
        resultElement.append( $("<script src='" + step1URL + "'></script>") );

        // Callback-Funktion für Schritt 1 des 3d-Party-Cookie Test
        (<any>window)._3rd_party_test_step1_loaded = function() {
            // URL + Result Element für Step 2
            let step2URL = "https://3partycookietest.leak-test.de/cookie.step2.php";
            let resultElement = $(element);

            // Status-Meldung setzen und Javascript hinzufügen
            resultElement.html("Prüfung läuft (2)");
            resultElement.append( $("<script src='" + step2URL + "'></script>") );
        };

        // Callback-Funktion für Schritt 2 des 3d-Party-Cookie Test
        (<any>window)._3rd_party_test_step2_loaded = function(cookieSuccess: boolean) {
            $("#has3rdPartyCookie").data("test3dPartyCookieStarted", false);

            // Prüfung erfolgreich abgeschlossen und Prüfergebnis zurückmelden
            sucess(cookieSuccess);
        };

        // Timeout-Funktion falls der Test nicht abgeschlossen wurde
        window.setTimeout(function() {
            // Prüfe ob schon ein Ergebnis vorliegt
            if ( $(element).data("test3dPartyCookieStarted") == true ) {
                // Kein Prüfergebnis, daher Fehlermeldung ausgeben
                failed();
            }

            // Status-Element entfernen
            $(element).removeData("test3dPartyCookieStarted");
        }, 7*1000);
    }

    /**
     * Bietet der Browser Canvas-Support?
     * @returns {boolean}
     */
    public static getCanvasStatus():boolean{
        let elem = document.createElement('canvas');
        return !!(elem.getContext && elem.getContext('2d'));
    }

    /**
     * Canvas: Erzeuge Beispiel-Grafik aus diversen Elementen für die Hash-Erstellung
     * Quelle: https://github.com/Valve/fingerprintjs2/blob/master/fingerprint2.js
     *
     * @return {string}
     */
    public static getCanvasFingerprintSampleImage():string {
        let canvas = document.createElement('canvas');
        canvas.width = 400;
        canvas.height = 200;
        canvas.style.display = 'inline';
        let ctx = canvas.getContext('2d');
        ctx.rect(0, 0, 10, 10);
        ctx.rect(2, 2, 6, 6);
        ctx.textBaseline = 'alphabetic';
        ctx.fillStyle = '#3cc5d1';
        ctx.fillRect(125, 1, 62, 20);
        ctx.fillStyle = '#3285ba';
        ctx.font = '11pt no-real-font-123';
        ctx.fillText('Franz jagt im komplett verwahrlosten \uD83D\uDE03', 2, 15);
        ctx.fillStyle = 'rgba(89, 179, 0, 0.4)';
        ctx.font = '18pt Arial';
        ctx.fillText('Taxi quer durch Bayern \uD83D\uDE3A', 4, 45);
        ctx.globalCompositeOperation = 'multiply';
        ctx.fillStyle = 'rgb(60, 197, 209)';
        ctx.beginPath();
        ctx.arc(50, 50, 50, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fill();
        ctx.fillStyle = 'rgb(0,255,255)';
        ctx.beginPath();
        ctx.arc(100, 50, 50, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fill();
        ctx.fillStyle = 'rgb(255,255,0)';
        ctx.beginPath();
        ctx.arc(75, 100, 50, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fill();
        ctx.fillStyle = 'rgb(255,0,255)';
        ctx.arc(75, 75, 75, 0, Math.PI * 2, true);
        ctx.arc(75, 75, 25, 0, Math.PI * 2, true);
        ctx.fill('evenodd');

        return canvas.toDataURL();
    }

    /**
     * Bietet der Browser WebGL Unterstützung?
     *
     * @returns {boolean}
     */
    public static getWebGLStatus():boolean {
        let canvasID = "webgl",
            canvas = <HTMLCanvasElement>document.getElementById(canvasID),
            gl;

        try {
            gl = canvas.getContext("webgl");
        } catch (x) {
            gl = null;
        }

        if (gl === null) {
            try {
                gl = canvas.getContext("experimental-webgl");
            } catch (x) {
                gl = null;
            }
        }

        if(gl) {
            return true;
        } else return "WebGLRenderingContext" in window;
    }

    /**
     * Welche Grafikkarte bietet die WebGL Unterstützung?
     *
     * @returns {string}
     */
    public static getWebGLVendor():string {
        try {
            let hersteller: string;
            let canvas = document.createElement("canvas");
            let gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl") as any as WebGLRenderingContext;
            let extension = gl.getExtension("WEBGL_debug_renderer_info");
            if (extension !== undefined) {
                // Via Debug-Extension
                hersteller = gl.getParameter(extension.UNMASKED_VENDOR_WEBGL);
                if(hersteller !== undefined) {
                    let grafikkarte = gl.getParameter(extension.UNMASKED_RENDERER_WEBGL);
                    if(grafikkarte !== undefined) {
                        if (hersteller.indexOf("Google Inc.") !== -1) {
                            hersteller = grafikkarte.replace(" OpenGL Engine", "").replace("ANGLE (","").replace(")","");
                        } else {
                            hersteller = hersteller + " (" + grafikkarte.replace(" OpenGL Engine", "") + ")";
                        }
                    }
                } else {
                    // Hersteller wird nicht übermittelt
                    hersteller = null;
                }
            } else {
                // Notwendige WebGL Extension fehlt (what?!)
                hersteller = null;
            }

            return hersteller;
        } catch (x) {
            console.warn(x);
            return null;
        }
    }

    /**
     * Welche WebGL Generation wird vom Browser unterstützt?
     *
     * @returns {webglversion}
     */
    public static getWebGLVersion():webglversion {
        try {
            let canvas = document.createElement("canvas");
            let gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl") as any as WebGLRenderingContext;
            let version: webglversion = { major : null, minor : null };

            if(gl) {
                let match = gl.getParameter(gl.VERSION).match(/(.*)( \()(.*)(\))/i);
                if (match !== null) {
                    // WebGL-Versionsangabe konnte geparsed werden
                    version.major = match[1];
                    if(match.length === 5) {
                        // Minor-Version konnte ermittelt werden
                        version.minor = match[3];
                    }
                } else {
                    // WebGL-Version konnte nicht geparsed werden
                    version.major = gl.getParameter(gl.VERSION);
                }
            } else {
                // WebGL steht nicht zur Verfügung?
                console.warn("Konnte kein WebGL Objekt instanzieren zur ermitteln der WebGL-Version");
                version = null;
            }

            return version;
        } catch (x) {
            return null;
        }
    }

    /**
     * Erzeuge Beispiel-Grafik aus diversen Elementen für die Hash-Erstellung
     * Quelle: https://github.com/Valve/fingerprintjs2/blob/master/fingerprint2.js
     *
     * @returns {string}
     */
    public static getWebGLprintSampleImage():string {
        let gl = this._getWebglCanvas() as any as WebGLRenderingContext;
        if (!gl) { return null; }
        let result = null;

        const vShaderTemplate = 'attribute vec2 attrVertex;varying vec2 varyinTexCoordinate;uniform vec2 uniformOffset;void main(){varyinTexCoordinate=attrVertex+uniformOffset;gl_Position=vec4(attrVertex,0,1);}';
        const fShaderTemplate = 'precision mediump float;varying vec2 varyinTexCoordinate;void main() {gl_FragColor=vec4(varyinTexCoordinate,0,1);}';
        let vertexPosBuffer = <any>gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, vertexPosBuffer);
        let vertices = new Float32Array([-0.2, -0.9, 0, 0.4, -0.26, 0, 0, 0.732134444, 0]);
        gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW);
        vertexPosBuffer.itemSize = 3;
        vertexPosBuffer.numItems = 3;
        let program = <any>gl.createProgram();          // Workaround mit <any>
        let vshader = gl.createShader(gl.VERTEX_SHADER);
        gl.shaderSource(vshader, vShaderTemplate);
        gl.compileShader(vshader);
        let fshader = gl.createShader(gl.FRAGMENT_SHADER);
        gl.shaderSource(fshader, fShaderTemplate);
        gl.compileShader(fshader);
        gl.attachShader(program, vshader);
        gl.attachShader(program, fshader);
        gl.linkProgram(program);
        gl.useProgram(program);
        program.vertexPosAttrib = gl.getAttribLocation(program, 'attrVertex');
        program.offsetUniform = gl.getUniformLocation(program, 'uniformOffset');
        gl.enableVertexAttribArray(program.vertexPosArray);
        gl.vertexAttribPointer(program.vertexPosAttrib, vertexPosBuffer.itemSize, gl.FLOAT, !1, 0, 0);
        gl.uniform2f(program.offsetUniform, 1, 1);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, vertexPosBuffer.numItems);
        try {
            if (gl.canvas.toDataURL) result = gl.canvas.toDataURL();
        } catch (e) {
            result = null;
        }

        return result;
    }

    /**
     * WebGL Details zusammenstellen
     * Quelle: https://github.com/Valve/fingerprintjs2/blob/master/fingerprint2.js
     *
     * @returns {array}
     */
    public static getWebGLDetails():string[] {
        let gl:any = this._getWebglCanvas() as any as WebGLRenderingContext;
        if (!gl) { return null; }

        let result:string[] = [];
        result.push('WebGL vendor: ' + gl.getParameter(gl.VENDOR));
        result.push('WebGL version: ' + gl.getParameter(gl.VERSION));
        result.push('WebGL Extensions: ' + (gl.getSupportedExtensions() || []).join('; '));
        result.push('WebGL aliased line width range: ' + this._fa2s(gl.getParameter(gl.ALIASED_LINE_WIDTH_RANGE), gl));
        result.push('WebGL aliased point size range: ' + this._fa2s(gl.getParameter(gl.ALIASED_POINT_SIZE_RANGE), gl));
        result.push('WebGL alpha bits: ' + gl.getParameter(gl.ALPHA_BITS));
        result.push('WebGL antialiasing :' + (gl.getContextAttributes().antialias ? DETECTPHRASE['ja'] : DETECTPHRASE['nein']));
        result.push('WebGL blue bits: ' + gl.getParameter(gl.BLUE_BITS));
        result.push('WebGL depth bits: ' + gl.getParameter(gl.DEPTH_BITS));
        result.push('WebGL green bits: ' + gl.getParameter(gl.GREEN_BITS));
        result.push('WebGL max anisotropy: ' + this._maxAnisotropy(gl));
        result.push('WebGL max combined texture image units: ' + gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS));
        result.push('WebGL max cube karte texture size: ' + gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE));
        result.push('WebGL max fragment uniform vectors: ' + gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS));
        result.push('WebGL max render buffer size: ' + gl.getParameter(gl.MAX_RENDERBUFFER_SIZE));
        result.push('WebGL max texture image units: ' + gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS));
        result.push('WebGL max texture size: ' + gl.getParameter(gl.MAX_TEXTURE_SIZE));
        result.push('WebGL max varying vectors: ' + gl.getParameter(gl.MAX_VARYING_VECTORS));
        result.push('WebGL max vertex attribs: ' + gl.getParameter(gl.MAX_VERTEX_ATTRIBS));
        result.push('WebGL max vertex texture image units: ' + gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS));
        result.push('WebGL max vertex uniform vectors: ' + gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS));
        result.push('WebGL max viewport dims: ' + this._fa2s(gl.getParameter(gl.MAX_VIEWPORT_DIMS), gl));
        result.push('WebGL red bits: ' + gl.getParameter(gl.RED_BITS));
        result.push('WebGL renderer: ' + gl.getParameter(gl.RENDERER));
        result.push('WebGL shading language version: ' + gl.getParameter(gl.SHADING_LANGUAGE_VERSION));
        try {
            result.push('WebGL stencil bits: ' + gl.getParameter(gl.STENCIL_BITS));
        } catch (e) { console.log(e); /* squelch */ }

        try {
            // Add the unmasked vendor and unmasked renderer if the debug_renderer_info extension is available
            let extensionDebugRendererInfo = gl.getExtension('WEBGL_debug_renderer_info');
            if (extensionDebugRendererInfo) {
                result.push('WebGL unmasked vendor: ' + gl.getParameter(extensionDebugRendererInfo.UNMASKED_VENDOR_WEBGL));
                result.push('WebGL unmasked renderer: ' + gl.getParameter(extensionDebugRendererInfo.UNMASKED_RENDERER_WEBGL));
            }
        } catch (e) { console.log(e); /* squelch */ }

        if (!gl.getShaderPrecisionFormat) {
            return result;
        }

        this._each(['FLOAT', 'INT'], function (numType:string) {
            detectInternetBrowser._each(['VERTEX', 'FRAGMENT'], function (shader:string) {
                detectInternetBrowser._each(['HIGH', 'MEDIUM', 'LOW'], function (numSize:string) {
                    detectInternetBrowser._each(['precision', 'rangeMin', 'rangeMax'], function (key:string) {
                        let format = gl.getShaderPrecisionFormat(gl[shader + '_SHADER'], gl[numSize + '_' + numType])[key];
                        if (key !== 'precision') {
                            key = 'precision ' + key;
                        }
                        let line = ['WebGL ', shader.toLowerCase(), ' shader ', numSize.toLowerCase(), ' ', numType.toLowerCase(), ' ', key, ': ', format].join('');
                        result.push(line);
                    })
                })
            })
        });

        return result;
    }

    /**
     * Get/Create WebGL Canvas
     *
     * @returns {*}
     */
    private static _getWebglCanvas():WebGLRenderingContext {
        let canvas = <HTMLCanvasElement>document.createElement('canvas');
        let gl:WebGLRenderingContext;
        try {
            gl = canvas.getContext('webgl') || 
                canvas.getContext('experimental-webgl') as any as WebGLRenderingContext;
        } catch (e) { /* squelch */ }
        if (!gl) { gl = null; }
        return gl;
    };

    /**
     * Viewport Dimension
     *
     * @param fa
     * @param gl
     * @returns {string}
     */
    private static _fa2s(fa:Array<string>, gl:WebGLRenderingContext | null):string {
        gl.clearColor(0.0, 0.0, 0.0, 1.0);
        gl.enable(gl.DEPTH_TEST);
        gl.depthFunc(gl.LEQUAL);
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
        return '[' + fa[0] + ', ' + fa[1] + ']';
    };

    /**
     * Max. Anisotropy
     *
     * @param gl
     * @returns {*}
     */
    private static _maxAnisotropy(gl:WebGLRenderingContext):number {
        let ext = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic');
        if (ext) {
            let anisotropy = gl.getParameter(ext.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
            if (anisotropy === 0) {
                anisotropy = 2;
            }
            return anisotropy;
        } else {
            return null;
        }
    };

    /**
     * Durchlaufen eines spezifischen Arrays/Objekts für die WebGL Details
     *
     * @param obj
     * @param iterator
     */
    private static _each(obj:any, iterator:any):void {
        if (Array.prototype.forEach && obj.forEach === Array.prototype.forEach) {
            obj.forEach(iterator);
        } else if (obj.length === +obj.length) {
            for (let i = 0, l = obj.length; i < l; i++) {
                iterator(obj[i], i, obj);
            }
        } else {
            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                    iterator(obj[key], key, obj);
                }
            }
        }
    };


}
